// [NOTE!] should be in sync with enum from payments-app
export enum MessageFromPopup {
  PlaceTestOrder = 'PlaceTestOrder',
}
